import { StudentData } from 'types/snackpack-student-data';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import useConfigStyles from '../../components/useConfigStyles';
interface SnackpackStudentDataProps {
  student: StudentData;
}
export default function SnackpackStudentData(props: SnackpackStudentDataProps) {
  const classes = useConfigStyles();

  const fieldDisplayNameMap: Map<string, string> = new Map([
    ["StateStudentId", "State Student Identifier"],
    ["MostRecentSchool", "Most Recent School"],
    ["AccountabilitySchool", "Accountability School Identifier"],
    ["SchoolEntryDate", "School Entry Date"],
    ["SchoolExitWithdrawalDate", "School Exit/Withdrawal Date"],
    ["GradeLevel", "Current Grade Level"],
    ["CumulativeDaysAttended", "Cumulative Number of Days Attended"],
    ["Homeless", "Homeless Student"],
    ["Immigrant", "Immigrant Student"],
    ["KansasAtRiskProgramParticipation", "Kansas At-Risk Program Participant"],
    ["EsolBilingualProgramEntryDate", "ESOL/Bilingual Program Entry Date"],
    ["FirstLanguage", "First Language"],
    ["EsolBilingualProgramParticipationCode", "ESOL/Bilingual Program Code"],
    ["NeglectedStudent", "Neglected Student"],
    ["TitleIParticipation", "Title I Participant"],
    ["LunchProgramEligibilityAtRiskFunding", "Eligibility for NSLP/At-Risk Funding"],
    ["ResidenceDistrict", "District of Residence"],
    ["Qualifiedfor504", "Qualified for 504"],
    ["PrimaryDisabilityIndicator", "Primary Disability Indicator"],
    ["GiftedStudentIndicator", "Gifted Student Indicator"]
  ]);

  return (
    <div className={classes.container + ' snackpack-student'}>
      <h2 className='snackpack-title'>Student Data</h2>
      <TableContainer component={Paper} style={{ margin: '24px auto', width: '100%' }}>
        <Table aria-label='student data table'>
          <TableBody style={{ width: '100%', display: 'flex', flexDirection: 'row', flexWrap: 'wrap', borderTop: '1px solid #ddd' }}>
            {Object.entries(props.student).map(([key, value]) => (
              <TableRow key={key} style={{ minWidth: 'calc(50%)', width: 'calc(50%)', maxWidth: 'calc(50%)', display: 'flex', padding: '8px 0px', 'borderBottom': '1px solid #ddd'}}>
                <TableCell style={{ width: 'calc(50%)', maxWidth: 'calc(50% - min(max(16px, 2vw), 32px))', fontWeight: 'bold', color: '#666', fontSize: '.9rem', 'margin': 'auto 0px auto 0px', padding: '8px min(max(8px, 1vw), 16px)', border: 'none' }}> 
                  { fieldDisplayNameMap.has(key) ? fieldDisplayNameMap.get(key) : key }
                </TableCell>
                <TableCell style={{ width: 'calc(50%)', maxWidth: 'calc(50% - min(max(16px, 2vw), 32px))', color: '#000', 'margin': 'auto auto auto 0px', padding: '8px min(max(8px, 1vw), 16px)', border: 'none' }} align='right'>
                  {String(value)}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}
